import { HANDLE } from 'constants/bounding-box';

const DEFAULT_WIDGET_DIMENSIONS = { widthPx: 450, heightPx: 160 };

const ANSWERS_LIMIT = 5;

const BOUNDING_BOX_CONFIG = {
  customHandle: HANDLE.SIDE_CORNERS,
};

const DEFAULT_SUBMIT_TEXT_COLOR = '#FFFFFF';
const DEFAULT_SUBMIT_BACKGROUND_COLOR = '#008577';

export {
  DEFAULT_WIDGET_DIMENSIONS,
  ANSWERS_LIMIT,
  BOUNDING_BOX_CONFIG,
  DEFAULT_SUBMIT_TEXT_COLOR,
  DEFAULT_SUBMIT_BACKGROUND_COLOR,
};
